import Vue from 'vue';

// axios
import axios from 'axios';

let baseURL;
let ssoURL;

const prodURL =
  window.location.origin.includes('indsiders.com') &&
  !window.location.origin.includes('dev') &&
  !window.location.origin.includes('homolog');
const homologURL = window.location.origin.includes('homolog');
const localhostURL = window.location.origin.includes('localhost');

// URLs API PHP
if (prodURL) {
  baseURL = 'https://api-php-v2.indsiders.com';
} else if (homologURL) {
  baseURL = 'https://app-indsiders-myind-api-php-homolog.azurewebsites.net';
} else {
  baseURL = 'https://app-indsiders-myind-api-php-dev.azurewebsites.net';
  baseURL = 'https://app-indsiders-myind-api-php-dev.azurewebsites.net';
}

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});

// URLs API .Net e SSO (Login)
if (prodURL) {
  baseURL = 'https://api-v2.indsiders.com';
  ssoURL = 'https://myind-v2.indsiders.com/login';
} else if (homologURL) {
  baseURL = 'https://app-indsiders-myind-api-homolog.azurewebsites.net';
  ssoURL = 'https://myind-homolog.indsiders.com/login';
} else if (localhostURL) {
  // eslint-disable-next-line no-undef
  baseURL = process.env.VUE_APP_DOTNET_API_URL || 'http://localhost:5000';
  ssoURL = 'http://localhost:8080/login';
} else {
  baseURL = 'https://app-indsiders-myind-api-dev.azurewebsites.net';
  ssoURL = 'https://myind-homolog.indsiders.com/login';
}

const evoAxiosIns = axios.create({
  baseURL
});

// Align default headers with curl expectations
evoAxiosIns.defaults.headers.common['Accept'] = 'application/json';
evoAxiosIns.defaults.headers.post['Content-Type'] = 'application/json';

// --- REQUEST INTERCEPTOR (Injeta o Token) ---
evoAxiosIns.interceptors.request.use(
  (config) => {
    const isSwitchUser = config.url?.includes('switch-user') || config.headers?.skipAuthHeader;
    if (config.headers?.skipAuthHeader) delete config.headers.skipAuthHeader;

    if (!isSwitchUser) {
      const userInfo = Vue.prototype.$cookies?.get('userInfo');
      // Allow manual override to match curl Authorization header exactly when needed
      const overrideToken = window?.localStorage?.getItem('adminBearerToken') || '';
      const temporaryToken = overrideToken || userInfo?.temporaryToken || '';

      if (temporaryToken) {
        config.headers.Authorization = `Bearer ${temporaryToken}`;
        config.headers.token = temporaryToken;
      } else {
        // Avoid sending empty Authorization header
        if (config.headers && 'Authorization' in config.headers) delete config.headers.Authorization;
        if (config.headers && 'token' in config.headers) delete config.headers.token;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// --- RESPONSE INTERCEPTOR (Trata erros globais) ---
evoAxiosIns.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response || {};

    if (status === 401) {
      const isAuthFlowPage = ['login', 'reset-password', 'reset-pin', 'forgot'].some((page) =>
        window.location.pathname.includes(page)
      );

      if (!isAuthFlowPage) {
        console.warn('[Axios] Sessão expirada (401). Redirecionando para login...');

        localStorage.clear();

        if (Vue.prototype.$cookies) {
          Vue.prototype.$cookies.remove('userInfo');
          Vue.prototype.$cookies.remove('permissions');
        }

        window.location.href = ssoURL;
      }
    }

    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;
Vue.prototype.$http2 = evoAxiosIns;

export default axiosIns;
